import React, { useEffect, useRef, useState, useContext } from "react";
import "./AddTopic.scss";
import { withTranslation } from "react-i18next";
import { Form, OverlayTrigger } from "react-bootstrap";
import Utils from "../../../../core/utilities/Utils";
import StandardService from "../../../../core//service/StandardService";
import { toast } from "react-toastify";
import { RegulationContext } from "../../../../App";
import { CATEGORYLIST, LS_AUTHORITY_KEY, USER_ROLE } from "../../../../core/constants/common";
import ESGDataSetService from "../../../../core/service/ESGDataSetService";
import LanguageSelector from "../../LanguageSelector/LanguageSelector";
import { loadLanguages } from "i18next";
// import LanguageSelector from "../../LanguageSelector/LanguageSelector";
// import LanguageSelector from "./LanguageSelector/LanguageSelector";

const AddTopic = ({ t, stdId, handleDiscard, editTopicId, handleSave, currentcategory, forESGDataSet = false }) => {
  const [validated, setValidated] = useState(false);
  const containerRef = useRef(null);
  const [topic, setTopic] = useState("");
  const [category, setCategory] = useState("");
  const [active, setActive] = useState(true);
  const [isEdit, setIsEdit] = useState(editTopicId ? true : false);
  const [checkShowInProfile, setShowInProfile] = useState(true);
  const { setGlbRegulations } = useContext(RegulationContext);
  const [code, setCode] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);
	const authority = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
  const [localizationData, setLocalizationData] = useState([]);
  const [primaryLangName, setPrimaryLangName] = useState();
  const [isStdTemplateConfig,setIsStdTemplateConfig] = useState(false);
  const [isLanguageAvailable,setIsLanguageAvailable] = useState(false);
  const [helpText, setHelpText] = useState('');
  useEffect(() => {
    // containerRef.current.scrollIntoView();
    if (window.location.href.includes('std_template_config')) {
      setIsStdTemplateConfig(true);
    }
    let lsLangAvailable = localStorage.getItem('languageAvailable');
    if(lsLangAvailable) {
      setIsLanguageAvailable(JSON.parse(lsLangAvailable));
    }   
    setIsEdit(editTopicId ? true : false);
    if(!editTopicId) {
      setIsLoaded(true);
    }
    editTopicId && getDetails(stdId, editTopicId);
  }, [isStdTemplateConfig,editTopicId]);


  const closeAdd = (e) => {
    e.preventDefault();
    handleDiscard(true);
  };

  const getDetails = (stdid, editId) => {
    let req;
    if (forESGDataSet) {
      req = ESGDataSetService.getTopic(editId, currentcategory);
    } else {
      req = StandardService.getTopicDetails(stdid, editId, authority.roles.includes(USER_ROLE.SUPER_ADMIN));
    }    
    req.then((response) => {
      const data = forESGDataSet ? response.data.data[0] : response.data;
      if (forESGDataSet) {
        setCode(data?.code);
      } else if(!isStdTemplateConfig || !isLanguageAvailable){
        if(data?.localizedContents && data?.localizedContents.length>0) { 
          setLocalizationData(data?.localizedContents);
        } else {
          const objLocal = {
            fieldName: 'name',
            languageCode: "",
            translatedValue: data?.name
        }
          setLocalizationData([objLocal]);
        }
      } 
      setTopic(data?.name);
      setShowInProfile(data?.showInProfile);
      setActive(data?.active);
      setHelpText(data?.helpText || '');
      setIsLoaded(true);
     
      // setCategory(currentcategory)
    })
    .catch((error) => { });
  };

  const saveTopic = (e) => {
    e.preventDefault();
    // if (!topic) {
    //   setValidated(true);      
    //   return;
    // }      
    const params = {
      showInProfile: checkShowInProfile,
      active: active,
      categoryType: currentcategory,
      helpText: helpText || null
    };
    let req;
   
    if (forESGDataSet) {
      params.name = topic.trim();
      params.mandatory = false;
      params.code = code;
      params.category = currentcategory;
      req = ESGDataSetService.addTopic(params);
    } else if(isStdTemplateConfig || !isLanguageAvailable) {
      params.name = topic.trim();
      req = StandardService.addTopic(params, stdId, authority.roles.includes(USER_ROLE.SUPER_ADMIN));
    } else {
      params.name = primaryLangName.trim();
      params.localizedContents= localizationData;
      req = StandardService.addTopic(params, stdId, authority.roles.includes(USER_ROLE.SUPER_ADMIN));
    }    
    req.then((response) => {
      if (response.status === 201 || response.status === 200) {
        toast.success("Success", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setTopic("");
        setShowInProfile(true);
        setValidated(false);
        setHelpText('');
        handleSave(stdId);
      }
    })
    .catch((error) => { });
  };

  const editTopic = (e) => {
    e.preventDefault();
    // if (!topic) {
    //   setValidated(true);      
    //   return;
    // }  
    const params = {
      showInProfile: checkShowInProfile,
      active: active,
      categoryType: currentcategory,
      helpText: helpText || null
    };
    let req;
    const enteredName = (forESGDataSet || isStdTemplateConfig || !isLanguageAvailable) ? topic : primaryLangName;
    if (!enteredName || !enteredName.trim()) {
      setValidated(true);
      return;
    }
    if (forESGDataSet) {
      params.name = topic.trim();
      params.id = editTopicId;
      params.mandatory = false;
      params.code = code;
      params.category = currentcategory;
      req = ESGDataSetService.updateTopic(params);
    } else if(isStdTemplateConfig || !isLanguageAvailable) {
      params.name = topic.trim();
      req = StandardService.editTopic(params, stdId, editTopicId, authority.roles.includes(USER_ROLE.SUPER_ADMIN));
    } else {
      params.name = primaryLangName.trim();
      params.localizedContents= localizationData;
      req = StandardService.editTopic(params, stdId, editTopicId, authority.roles.includes(USER_ROLE.SUPER_ADMIN));
    }
    req.then((response) => {
      if (response.status === 200) {
        toast.success("Success", {
          position: toast.POSITION.TOP_RIGHT,
        });
        // setTopic('');
        // setShowInProfile(true);
        setValidated(false);
        handleSave(stdId);
      }
    })
    .catch((error) => { });
  };

  const convertedDataVal = (data,nameVal) => {
    setPrimaryLangName(nameVal);
    setLocalizationData(data);
  }

  if (!isLoaded) {
    return <div>Loading...</div>;
  }
  return (
    <>
      <div className="AddTopic_card" id="idRiskParam" ref={containerRef}>
        <Form noValidate validated={validated}>
          <div className="row m-0">
          {(forESGDataSet || isStdTemplateConfig || !isLanguageAvailable) ? <div className="col-lg-12 p-0">
            <OverlayTrigger
                placement="top"
                overlay={Utils.renderTooltip(t("RiskParameterName.label"))}
              >
                
                  <label className="mb-1">{t("Topic.label")} &nbsp;*</label>
              </OverlayTrigger>

              <input
                type="text"
                className="form-control"
                value={topic}
                onChange={(e) => setTopic(e.target.value)}
                required
                maxLength={250}
              />
                          </div> 
            : <div className="col-lg-12 p-0">
                <LanguageSelector fieldLabel={t("Topic.label")} convertedData= {(data,nameVal)=>convertedDataVal(data,nameVal)} localizationData={localizationData}/>
            </div> }
            {
              forESGDataSet && 
              <div className="col-lg-12 p-2">
                <label className="mb-1">{t("Code.label")} &nbsp;*</label>
                <input
                  type="text"
                  className="form-control"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  required
                  maxLength={250}
                />
              </div>
            }
            <div className="col-lg-12 p-2">
              <label className="mb-1">{t("HelpText.label")}</label>
              <textarea
                className="form-control"
                value={helpText}
                onChange={(e) => setHelpText(e.target.value)}
                rows={3}
                maxLength={1000}
                placeholder={t("HelpText.placeholder.label") || "Enter help text"}
              />
            </div>
            {/* <div className="col-lg-6 p-2">
                  <OverlayTrigger
                    placement="top"
                    overlay={Utils.renderTooltip(t("RiskParameterName.label"))}
                  >
                    <span>
                      <label className="mb-1">{t("Category.label")}</label>&nbsp;*
                    </span>
                  </OverlayTrigger>

                  <select
                    className="form-select"
                    required
                    onChange={(e) => setCategory(e.target.value)}
                    value={category}
                  >
                    <option value="" disabled hidden>
                      {t("Select.label")}
                    </option>
                    {CATEGORYLIST?.map((item) => (
                      <option value={item.key} key={item.key}>
                        {item.value}
                      </option>
                    ))}
                  </select>
                </div> */}
            {/* <div className="col-lg-12 px-2">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={checkShowInProfile}
                  onChange={() => setShowInProfile(!checkShowInProfile)}
                />

                <label className="form-check-label" htmlFor="exampleCheck1">
                  {t("ShowInDashboard.label")}
                </label>
              </div>
            </div> */}
            <div className="col-lg-12 px-2">
              <div className="pb-2 form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={active}
                  onChange={() => setActive(!active)}
                />

                <label className="form-check-label" htmlFor="exampleCheck1">
                  {t("Active.label")}
                </label>
              </div>
              <div className="col-lg-12 p-2 text-center">
                <button
                  className="btn btn-secondary me-2 px-3"
                  onClick={closeAdd}
                >
                  {" "}
                  {t("Discard.label")}
                </button>
                {isEdit ? (
                  <button
                    className="btn btn-primary px-4"
                    onClick={editTopic}
                  >
                    {" "}
                    {t("Save.label")}
                  </button>
                ) : (
                  <button
                    className="btn btn-primary px-4"
                    onClick={saveTopic}
                  >
                    {" "}
                    {t("Save.label")}
                  </button>
                )}
              </div>
            </div>
          </div>
        </Form>
        {/* {isConfirmation && (
          <ConfirmationModal
            modalShow={true}
            messageText={messageConfirmation}
            callbackModal={handleActive}
            confirmBtn={t("Yes.label")}
            CancelBtn={t("No.label")}
          />
        )} */}
      </div>
    </>
  );
};

// AddTopic.propTypes = {};

// AddTopic.defaultProps = {};

export default withTranslation()(AddTopic);
